<template>
  <div>
    <div v-show="!isvaildcheck" class="centerContainer">
      <button class="imgButton" @click="checkIsAdmin">
        <svg width="96" height="96" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" v-show="showLock">
          <rect x="6" y="22" width="36" height="22" rx="2" fill="none" stroke="#333" stroke-width="4" stroke-linejoin="round"/>
          <path d="M14 22V14C14 8.47715 18.4772 4 24 4C29.5228 4 34 8.47715 34 14V22" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M24 30V36" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <svg width="96" height="96" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" v-show="!showLock">
          <rect x="7" y="22.0476" width="34" height="22" rx="2" fill="none" stroke="#333" stroke-width="4" stroke-linejoin="round"/>
          <path d="M14 22V14.0047C13.9948 8.87022 17.9227 4.56718 23.0859 4.05117C28.249 3.53516 32.9673 6.97408 34 12.0059" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M24 30V36" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <el-dialog title="身份校验" :visible.sync="isAdminDialog" width="30%">
              <el-form ref="paperform" :inline="true" :model="admincheck" label-width="80px">
                <el-row>
                  <el-col :span="24">
                  <el-form-item label="密码" prop="pass">
                      <el-input v-model="admincheck.password"></el-input>
                  </el-form-item>
                  </el-col>
                </el-row>
              </el-form>

              <div slot="footer" class="dialog-footer">
                  <el-button @click="isAdminDialog = false; showLock = true;">取 消</el-button>
                  <el-button type="primary" @click="vaildIsAmind">确 认</el-button>
              </div>
      </el-dialog>
    </div>

    <div v-show="isvaildcheck">

      <el-form >
        <el-form-item style="width: 5%; float: left; margin-left:85%;">
          <el-select v-model="search.typeIds" placeholder="文章类型">
            <el-option v-for="option in paperTypes" :key="option.id" :label="option.name" :value="option.name" @click.native="getPaperByType(option)"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="width: 2%; float: left;">
          <el-button type="info" style="margin-bottom: 0.3%;margin-left: 95%;" @click="showPaperDialog">上 传</el-button>
        </el-form-item> 

      </el-form>
    
      <el-table
          :data="tableData"
          style="width: 100%">
        <el-table-column prop="publish_time" label="发布日期" width="180" align="center"></el-table-column>
        <el-table-column prop="author" label="作者" width="180" align="center"></el-table-column>
        <el-table-column prop="type_name" label="类型" width="180" align="center"></el-table-column>

        <el-table-column label="文章" align="center">
          <template slot-scope="scope">
            <a :href="scope.row.path" target="_blank">{{ scope.row.name }}</a>
            <router-link :to="'/paper/' + paperInfo.uid">
              {{ scope.row.name }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="doi" label="DOI" align="center">
          <template slot-scope="scope">
            <a target="_blank" style="color:#007bff;" v-if="scope.row.doi!=null"
              v-bind:href="scope.row.doi">
              {{ scope.row.doi }}
            </a>
            <span v-else> {{ scope.row.doi }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
            @size-change="getPaperList"
            @current-change="getPaperList"
            :page-sizes="[20, 50, 100]"
            :page-size="pagesize"
            :page-count="pageNo"
            layout="->, jumper, total, sizes, prev, pager, next"
            :total="total"
        >
        </el-pagination>
    </div>

      <el-dialog title="上传文章" :visible.sync="isPaperDialog" width="30%">
              <el-form ref="paperform" :inline="true" :model="paperInfo" label-width="80px">

                <el-row>
                  <el-col :span="24">
                  <el-form-item label="作者" prop="author">
                      <el-input v-model="paperInfo.author"></el-input>
                  </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="24">
                  <el-form-item label="文章名称" prop="name">
                      <el-input v-model="paperInfo.name"></el-input>
                  </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="24">
                  <el-form-item label="类型" prop="type_id">
                    <el-select v-model="paperInfo.type_id" placeholder="文章类型">
                      <el-option v-for="option in paperTypes" :key="option.id" :label="option.name" :value="option.id"></el-option>
                    </el-select>
                  </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="24">
                  <el-form-item label="doi" prop="doi">
                      <el-input v-model="paperInfo.doi"></el-input>
                  </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="24">
                  <el-form-item label="发布日期" prop="publish_time">
                      <el-date-picker class="sw-search-input" @change="handleDateChange"
                                      v-model="paperInfo.publish_time" format="yyyy-MM-dd"
                                      type="date"
                                      placeholder="选择日期" align="top" :clearable="false">
                      </el-date-picker>
                  </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="24">
                  <el-form-item label="出版社" prop="publish_house">
                      <el-input v-model="paperInfo.publish_house"></el-input>
                  </el-form-item>
                  </el-col>
                </el-row>
                
                <el-row>
                  <el-col :span="24">
                  <el-form-item label="备注" prop="memo">
                      <el-input v-model="paperInfo.memo"></el-input>
                  </el-form-item>
                  </el-col>
                </el-row>
                
                <el-row>
                  <el-col :span="24">
                  <el-form-item label="上传文章" prop="file">
                      <el-upload :action="uploadPictureHost" :limit="2" :http-request="uploadPaperFile" style="display:inline-block;">
                        <el-button type="text" aria-hidden="true" class="op-icon fa">
                          <i class="el-icon-video-camera-solid" v-show="!showFile"/>
                          <p v-show="showFile">上传成功</p>
                        </el-button>
                      </el-upload>                
                    </el-form-item>
                  </el-col>
                </el-row>

              </el-form>

              <div slot="footer" class="dialog-footer">
                  <el-button @click="isPaperDialog = false">取 消</el-button>
                  <el-button type="primary" @click="uploadPaper()">确 认</el-button>
              </div>

      </el-dialog>
    </div>
  </div>
</template>

<script>

import {getAllPaper, addPaper, putPaper, rightCheck, getPaperType} from "../../api";


export default {
  data() {
    return {
      tableData: [],
      paperTypes: [],
      paperInfo: {
        author: "",
        name: "",
        doi: "",
        publish_time: "",
        publish_house: "",
        memo: "",
        path: "",
        type_id: "",
        uid: "",
      },
      pageNo: 1,
      pagesize: 20,
      total: 20,
      isPaperDialog: false,
      showFile: false,
      uploadPictureHost: process.env.VUE_APP_BASE_API + "/paper/upload",
      isvaildcheck: false,
      showLock: true,
      admincheck: {
        password: "",
      },
      isAdminDialog: false,
      search: {
        typeIds: "",
      },
    }
  },
  created() {
    this.getPaperList();
    this.admincheck.password = sessionStorage.getItem("paperPossword");
    if (this.admincheck.password != null) {
      console.log(this.admincheck.password);
      this.vaildIsAmind();
    }
    getPaperType().then(res => {
      this.paperTypes = res.data;
    })
  },
  methods: {
    showPaperDialog() {
      this.isPaperDialog = true;
    },
    getPaperList() {
      getAllPaper(this.pagesize, this.pageNo, this.search.typeIds).then(res => {
        this.tableData = res.data;
        this.total = res.total;
      })
    },
    getPaperByType(option){
      getAllPaper(this.pagesize, this.pageNo, option.id).then(res => {
        this.tableData = res.data;
        this.total = res.total;
      })
    },
    handleDateChange() {

    },
    uploadPaper() {
      console.log(this.paperInfo)
      if (this.paperInfo !== null && this.paperInfo.path != "" && this.paperInfo.publish_time != ""){
        this.paperInfo.publish_time = new Date(this.paperInfo.publish_time).toISOString().substring(0, 10);
        addPaper(this.paperInfo).then(res => {
          this.isPaperDialog = false;
          this.getPaperList();
          this.paperInfo.path = "";
        })
      }
    },
    uploadPaperFile(param) {
        let files = param.file;
        var formData = new FormData();
        formData.append('multipartFile', files);
        putPaper(formData).then(res => {
          this.showFile = true;
          this.paperInfo.path = res.data.path
          this.paperInfo.uid = res.data.uid
        });
    },
    checkIsAdmin() {
      this.isAdminDialog = true;
      this.showLock = false;
    },
    vaildIsAmind() {
      this.isAdminDialog = false;
      let param = {
        tb_name: "t_paper",
        password: this.admincheck.password
      }
      rightCheck(param).then(res=>{
          sessionStorage.setItem("paperPossword", this.admincheck.password);
          this.isAdminDialog = false;
          this.isvaildcheck = true;
      })
    }
  }
}
</script>

<style>
  
</style>